import React from "react";

const ProfileIcon = () => {
  return (
    <>
      <svg width="14.199" height="16.549" viewBox="0 0 14.199 16.549">
        <g
          id="Group_351"
          data-name="Group 351"
          transform="translate(-3.4 -2.268)"
        >
          <circle
            id="Ellipse_84"
            data-name="Ellipse 84"
            cx="3"
            cy="3"
            r="3"
            transform="translate(7.543 2.868)"
            fill="none"
            stroke="#000"
            stroke-width="1.2"
          />
          <path
            id="Path_2542"
            data-name="Path 2542"
            d="M17,16.97q0-.2,0-.4C17,14.6,14.09,13,10.5,13S4,14.6,4,16.573s0,3.573,6.5,3.573a18.35,18.35,0,0,0,4.063-.347"
            transform="translate(0 -1.929)"
            fill="none"
            stroke="#000"
            stroke-linecap="round"
            stroke-width="1.2"
          />
        </g>
      </svg>
    </>
  );
};

export default ProfileIcon;
